<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <template #activator="{ props }">
      <a href="#" class="link-activator" v-bind="props" @click.prevent>
        {{ t('taxReductionInfo.buttonActivatorText') }}
      </a>
    </template>

    <v-card>
      <v-card-title>{{ t('taxReductionInfo.title') }}</v-card-title>
      <v-card-text>
        <h4 class="my-4">
          {{ t('taxReductionInfo.info') }}
        </h4>
        <p v-for="prerequisite in prerequisites" :key="prerequisite" class="body-2 mb-4">
          {{ prerequisite }}
        </p>
        <p class="subtitle-2 mt-8">
          {{ t('taxReductionInfo.moreInfo') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="outlined" color="primary" @click="dialog = false">
          {{ t('generic.labels.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useLabel } from '@/composables/useLabel';
import i18n from '@/plugins/i18n';

export default defineComponent({
  setup() {
    const dialog = ref(false);
    const { t } = useLabel();

    // Fix to sort out the array of strings for the prerequisites from i18n.
    const prerequisites = computed(() => {
      const globalI18n = i18n.vueI18n.global;
      const locale = globalI18n.locale.value;
      const messages = globalI18n.getLocaleMessage(locale);

      const items = messages.taxReductionInfo.prerequisites;
      return items as Array<string>;
    });

    return {
      t,
      dialog,
      prerequisites,
    };
  },
});
</script>

<style scoped>
.link-activator {
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  vertical-align: baseline;
}
</style>
